import { render } from "./LoginEsercenti.vue?vue&type=template&id=ef81590e"
import script from "./LoginEsercenti.vue?vue&type=script&lang=js"
export * from "./LoginEsercenti.vue?vue&type=script&lang=js"
script.render = render

export default script